var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5C9.41421 13.5 9.75 13.1642 9.75 12.75C9.75 12.3358 9.41421 12 9 12C8.58579 12 8.25 12.3358 8.25 12.75C8.25 13.1642 8.58579 13.5 9 13.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26699 6.42007C8.90281 6.43606 8.70861 6.58258 8.64138 6.72542C8.465 7.1002 8.01819 7.26103 7.64341 7.08464C7.26863 6.90825 7.1078 6.46144 7.28419 6.08666C7.67582 5.25453 8.51953 4.95143 9.20122 4.92151C9.85697 4.89273 10.673 5.1016 11.1245 5.69033C11.4719 6.14336 11.6671 6.71764 11.5883 7.32146C11.5083 7.93373 11.1591 8.48294 10.5924 8.89982C9.83575 9.4565 9.83709 9.74053 9.83728 9.78189C9.83729 9.78249 9.83729 9.78304 9.83729 9.78354C9.83729 10.1978 9.5015 10.5335 9.08729 10.5335C8.67307 10.5335 8.33729 10.1978 8.33729 9.78354C8.33729 9.06601 8.75465 8.38965 9.70357 7.69156C9.99524 7.47699 10.082 7.27168 10.1009 7.12731C10.1208 6.97449 10.0775 6.79002 9.93419 6.60312C9.92411 6.58997 9.86933 6.53526 9.73216 6.48597C9.6012 6.4389 9.43652 6.41263 9.26699 6.42007Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.25C4.425 17.25 0.75 13.575 0.75 9C0.75 4.425 4.425 0.75 9 0.75C13.575 0.75 17.25 4.425 17.25 9C17.25 13.575 13.575 17.25 9 17.25ZM9 2.25C5.25 2.25 2.25 5.25 2.25 9C2.25 12.75 5.25 15.75 9 15.75C12.75 15.75 15.75 12.75 15.75 9C15.75 5.25 12.75 2.25 9 2.25Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestionMark);
export default __webpack_public_path__ + "static/media/circle-question-mark.9b6d3414391a6cd45e3e5095b65f9103.svg";
export { ForwardRef as ReactComponent };